import React from "react";
import useRevealOnScroll from "../hooks/useRevealOnScroll";

function SectionHeader({ icon, eyebrow, title, align = "center" }) {
  const alignment =
    align === "left" ? "items-start text-left" : "items-center text-center";
  const { elementRef, isVisible } = useRevealOnScroll();

  return (
    <div
      ref={elementRef}
      className={`flex flex-col ${alignment} ${
        isVisible ? "animate-fade-in-up-slow" : ""
      }`}
    >
      {icon && (
        <div className="mb-3 flex justify-center text-4xl text-coding-color">
          {icon}
        </div>
      )}
      {eyebrow && (
        <p className="text-xs font-medium uppercase tracking-[0.2em] text-coding-color">
          {eyebrow}
        </p>
      )}
      <h2 className="mt-2 font-title text-3xl font-bold text-white md:text-4xl">
        {title}
      </h2>
    </div>
  );
}

export default SectionHeader;
